// @ts-nocheck
import * as React from "react";

const TechnologyOutline: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
            <path d="M0 0h100v100H0z" fill="none" />
            <path
                d="M75.9 39.2c1.2 1.3 1.7 3 1.5 4.8L76 54.4c-.2 1.7-1.2 3.2-2.7 4.1l-2.2 16.2c-.2 1.6-1.6 2.8-3.2 2.8h-3.8c-1.7 0-3-1.2-3.2-2.9l-2.2-16.2c-1.5-.8-2.5-2.4-2.8-4.1L54.6 44c-.4-3.4 2-6.4 5.4-6.8h2.4c.5 0 1 .2 1.3.6l2.3 2.8 2.3-2.8c.3-.4.8-.6 1.3-.6h1.7c1.8-.1 3.5.7 4.6 2zM59.3 29.2a6.7 6.7 0 1 1 13.4 0 6.7 6.7 0 0 1-13.4 0zM52.9 30.4s-.1 0 0 0l-1.8 1.3c-.8-.4-1.5-.7-2.3-1l-.4-2.1c-.3-1.8-1.8-3-3.6-3h-2.5c-1.8 0-3.3 1.3-3.6 3l-.4 2.1c-.8.3-1.6.6-2.3 1l-1.7-1.2c-1.5-1-3.5-.9-4.7.4l-1.8 1.8c-1.3 1.3-1.4 3.2-.4 4.7l1.2 1.7c-.4.8-.7 1.5-1 2.3l-2.1.4c-1.8.3-3 1.8-3 3.6v2.5c0 1.8 1.3 3.3 3.1 3.6l2.1.4c.3.8.6 1.6 1 2.3l-1.2 1.7c-1 1.5-.9 3.5.4 4.7l1.8 1.8c1.3 1.3 3.2 1.4 4.7.4l1.7-1.2c.8.4 1.5.7 2.3 1l.4 2.1c.3 1.8 1.8 3 3.6 3h2.5c1.8 0 3.3-1.3 3.6-3l.4-2.1c.8-.3 1.6-.6 2.3-1l1.7 1.2"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <path
                d="M49.6 52.7c-3.4 3.3-8.9 3.2-12.2-.2-3.2-3.3-3.2-8.7 0-12 3-3 7.9-3.4 11.3-.8"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
        </svg>
    );
};

export default React.memo(TechnologyOutline);
